//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import Requisites from '~/views/TradersRequisitesAndDevices/Requisites/Table.vue';
import Devices from '~/views/TradersRequisitesAndDevices/Devices/Table.vue';
import Relations from '~/views/TradersRequisitesAndDevices/RequisiteUser/Table.vue';
import SettingsModal from '~/views/TradersRequisitesAndDevices/RequisiteUser/SettingsModal.vue';

export default {
  components: {
    Requisites,
    Devices,
    Relations,
    SettingsModal,
  },

  data() {
    return {
      settingsModal: false,
    };
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadRequisites(),
      this.loadDevices(),
      this.loadCurrencies(),
      this.loadPaymentMethods(),
      this.loadGroups(),
      this.loadDataAction(),
      this.loadSettings(),
    ]);
    this.setGeneralLoader(false);
  },

  computed: {
    ...mapState('statisticsRequisiteUser', {
      relationsPerProfile: 'perProfile',
    }),
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('tradersRequisites', {
      loadRequisites: 'loadData',
    }),
    ...mapActions('tradersDevices', {
      loadDevices: 'loadData',
    }),
    ...mapActions('tradersCurrencies', {
      loadCurrencies: 'loadData',
    }),
    ...mapActions('tradersPaymentMethods', {
      loadPaymentMethods: 'loadData',
    }),
    ...mapActions('usersGroups', {
      loadGroups: 'getGroups',
    }),
    ...mapActions('statisticsRequisiteUser', {
      loadDataAction: 'loadData',
      loadSettings: 'loadBookingSettings',
    }),
  },
};
